var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.858 7.002a5.465 5.465 0 0 0-4.032 1.93l-.807-.8a.305.305 0 0 0-.519.22v2.621c0 .171.134.306.306.306h2.62c.276 0 .41-.33.214-.52l-.947-.953A4.275 4.275 0 0 1 12 8.224c2.64 0 4.729 2.407 4.191 5.138-.33 1.693-1.717 3.043-3.409 3.343a4.275 4.275 0 0 1-4.918-3.153.616.616 0 0 0-.587-.44.61.61 0 0 0-.599.751A5.494 5.494 0 0 0 12 18a5.501 5.501 0 0 0 5.499-5.658c-.086-2.982-2.658-5.414-5.64-5.34Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75v3l2 1.5",
    stroke: "#F44336",
    strokeLinecap: "round"
  })));
};
export default SvgCancel;